import { skillAoeRangeMultiplier } from "@/character/skills/aoe-range";
import { skillEffectiveBuffDurationMs } from "@/character/skills/buff-duration";
import { skillEffectiveCooldownMs } from "@/character/skills/cooldown-upgrade";
import { skillCooldownMs } from "@/character/skills/constants";
import {
  DEFAULT_ATTACK_SKILL_DAMAGE_MULT,
  type SkillBarState,
} from "@/character/skills/types";
import { skillById } from "@/character/skills/storage";
import type { HomeSkillRuntimePayload } from "@/home/home-events";
import type { HomeEconomy } from "@/home/economy";

export function buildPetSkillRuntimePayload(
  bar: SkillBarState,
  economy: HomeEconomy,
): HomeSkillRuntimePayload {
  const skills = bar.library.map((skill) => ({
    id: skill.id,
    name: skill.name,
    kind: skill.kind,
    durationMs:
      skill.kind === "buff" ? skillEffectiveBuffDurationMs(skill) : skill.durationMs,
    spritesheetDataUrl: skill.spritesheetDataUrl,
    grid: skill.grid,
    frameRate: skill.frameRate,
    cooldownMs: skillEffectiveCooldownMs(skill),
    damageMultiplier:
      skill.kind === "attack"
        ? skill.damageMultiplier ?? DEFAULT_ATTACK_SKILL_DAMAGE_MULT
        : undefined,
    attackPattern: skill.kind === "attack" ? skill.attackPattern ?? "single" : undefined,
    aoeRangeMultiplier:
      skill.kind === "attack" && skill.attackPattern === "aoe"
        ? skillAoeRangeMultiplier(skill)
        : undefined,
    buffStatBonus: skill.kind === "buff" ? skill.buffStatBonus : undefined,
  }));
  const slots = bar.slots.map((id) => {
    if (!id || !skillById(bar, id)) return null;
    return id;
  });
  return {
    unlockedSlots: economy.petSkillSlotsUnlocked,
    cooldownMs: skillCooldownMs(0),
    slots,
    skills,
  };
}
